export default __webpack_public_path__ + "static/avis_verifies-289bfa31456817ec68727545e2167caf.png";